import 'core-js';
import 'regenerator-runtime/runtime';
import i18next from 'i18next';
import nl from '../../resources/translations/nl.json';

// Create a lightweight synchronous translator with only NL translations
const syncTranslator = i18next.createInstance();

// Initialize synchronously with just NL resources
syncTranslator.init({
  lng: 'nl',
  fallbackLng: 'nl',
  debug: false,
  ns: 'translations',
  defaultNS: 'translations',
  resources: {
    nl: { translations: nl },
  },
  interpolation: {
    escapeValue: false,
  },
});

// Set up window.translator immediately for instant availability
window.translator = syncTranslator;
window.translator.isInitialized = true;

export default syncTranslator;
